import { createPageAnalyticsFn } from 'src/libs/Analytics';

type CandidateManagementLinkAnalyticEvents =
  | {
      event: 'banner_content_pressed';
      attributes: {
        bannerElement:
          | 'Go to Verifications Tab'
          | 'Go to Why Verify SEEK Pass Page';
        displayedBanner:
          | 'Career History Verification Banner'
          | 'Candidate Management - Verified by SEEK Pass Banner';
        seekListingId: number;
        candidateId: number;
      };
    }
  | {
      event: 'verifications_tab_pressed';
      attributes: {
        seekListingId: number;
        candidateId: number;
      };
    }
  | {
      event: 'alert_dismiss_pressed';
      attributes: {
        alertShownMessageCode: 'Candidate Management - Verified by SEEK Pass Banner';
        seekListingId: number;
        candidateId: number;
      };
    }
  | {
      event: 'learn_how_credential_are_verified_pressed';
      attributes: {
        actionOrigin:
          | 'Candidate Management Profile - Verification Tab'
          | 'Candidate Management Profile - Profile Tab';
      };
    };

type CandidateManagementViewAnalyticEvents = {
  event: 'candidate_management_banner_displayed';
  attributes: {
    displayedBanner: 'Career History Verification Banner';
    seekListingId: number;
    candidateId: number;
  };
};

export const createPageAnalytics = createPageAnalyticsFn<
  CandidateManagementLinkAnalyticEvents,
  CandidateManagementViewAnalyticEvents
>({
  siteSubsection: 'candidate',
});

export type ProfileDrawerPageAnalytics = ReturnType<typeof createPageAnalytics>;
